import { z } from 'zod'

export const metricPeriods = ['Сегодня', '7 дней', '30 дней'] as const
export const metricPeriodSchema = z.enum(metricPeriods)
export type MetricPeriod = z.infer<typeof metricPeriodSchema>

export const periodCodes: Record<MetricPeriod, 'today' | '7d' | '30d'> = {
  'Сегодня': 'today',
  '7 дней': '7d',
  '30 дней': '30d',
}

export const valueFormatSchema = z.enum(['currency', 'count', 'percent', 'points'])

export const kpiSchema = z.object({
  key: z.string(),
  label: z.string(),
  value: z.number().nullable(),
  format: valueFormatSchema,
  delta: z
    .object({
      value: z.number(),
      format: valueFormatSchema,
      direction: z.enum(['up', 'down']),
    })
    .nullable()
    .default(null),
  note: z.string().nullable().default(null),
  hint: z.string().nullable().default(null),
})

export const attentionLevels = ['high', 'mid', 'low'] as const

export const overviewSchema = z.object({
  period: metricPeriodSchema,
  origin: z.enum(['demo', 'live']),
  currency: z.string().default('UAH'),
  generatedAt: z.iso.datetime().nullable().default(null),
  kpis: z.array(kpiSchema),
  chart: z.object({
    title: z.string(),
    unit: z.string(),
    bars: z.array(z.object({ label: z.string(), value: z.number() })),
  }),
  plans: z.array(
    z.object({
      key: z.string(),
      name: z.string(),
      price: z.number(),
      count: z.number(),
      share: z.number().min(0).max(100),
      mrr: z.number(),
    }),
  ),
  load: z.object({
    bookings: z.number(),
    completed: z.number(),
    cancelled: z.number(),
    cancelRate: z.number(),
    reminders: z.number(),
    deliveryRate: z.number().nullable(),
    smsSpent: z.number(),
    workingSalons: z.number(),
    newCustomers: z.number(),
  }),
  attention: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      note: z.string(),
      level: z.enum(attentionLevels),
    }),
  ),
  notes: z.array(z.string()).default([]),
})

export type Kpi = z.infer<typeof kpiSchema>
export type Overview = z.infer<typeof overviewSchema>
export type ValueFormat = z.infer<typeof valueFormatSchema>
